import {Component, OnInit, Input, ElementRef, Renderer2, ChangeDetectorRef, HostListener} from '@angular/core';
import {GeneralService} from '../../../services/general.service';
import {AlbumsService} from "../../../api-client/api/albums.service";
import {LoadingHelperService} from "../../loading-helper/loading-helper.service";
import {hoslog} from "../../../app.constants";
import {MixpanelService} from '../../../services/mixpanel.service';

@Component({
  selector: 'app-album-peek-popup',
  templateUrl: './peek-popup.component.html',
  styleUrls: ['./peek-popup.component.scss'],
  /*host: {
    '(document:click)': 'close($event)'
  }*/
})
export class AlbumPeekPopupComponent implements OnInit {

  @Input('albumId') id;

  public data = null;
  public loading = false;

  public isOpened: boolean = false;
  private _headerHeight = 174;
  private _footerHeight = 134;
  // private subscription: Subscription;
  // private tmp = document.createElement('div');
  private contentContainer = document.getElementsByClassName('router-container')[0];

  constructor(private albumsService: AlbumsService,
              public loadingHelperService: LoadingHelperService,
              private _el: ElementRef,
              private renderer: Renderer2,
              private gs: GeneralService,
              private mixpanelService: MixpanelService,
              private changeDetectorRef: ChangeDetectorRef) {
    // this.tmp.className = "peek-overlay";
  }

  ngOnInit() {
  }

  handlePopup(event) {
    let subContainerHeader = document.getElementsByClassName('sub-container-header')[0];
    if (subContainerHeader) {
      this._headerHeight += 45; // consider the extra header
    }
    this.gs.setOpenPeekPopup(true);
    this.preventRedirect(event);
    this.isOpened = !this.isOpened;

    if (this.isOpened) {
      this.changeDetectorRef.detectChanges();
      this.positioningPopup();
      this.trackPopupToggle();
      if (this.data == null) {
        this.loadAlbumDetail();
      }
    } else {
      this.close(undefined); // close will also call the tracking
    }
  }

  public loadAlbumDetail() {
    this.loadingHelperService.startLoading("ALBUM_PEEK_DETAIL");
    this.albumsService.getAlbumDetail(this.id)
      .subscribe(
        res => {
          hoslog("getAlbumDetail loaded" /*+ JSON.stringify(res)*/);
          this.data = res;
          this.changeDetectorRef.detectChanges();
          this.positioningPopup();
          setTimeout(() => this.positioningPopup(), 0);
          this.loadingHelperService.loadingOK("ALBUM_PEEK_DETAIL");
        },
        error => {
          hoslog("getAlbumDetail error: " + JSON.stringify(error));
          this.loadingHelperService.loadingKO(error, "ALBUM_PEEK_DETAIL");
        });
  }

  private trackPopupToggle() {
    const action = this.isOpened ? 'open' : 'close';
    this.mixpanelService.track('AlbumPeekPopup', {action: action, albumId: this.id});
  }

  preventRedirect(event) {
    // do not pass events to parent elements
    if (event && event.stopPropagation) event.stopPropagation();
    if (event && event.preventDefault) event.preventDefault();
  }

  close(event) { // TODO check the event parameter (is it used?)
    this.preventRedirect(event);
    // if ((!event || !this._el.nativeElement.contains(event.target)) && this.gs.getOpenPeekPopup()) {
    this.isOpened = false;
    this.gs.setOpenPeekPopup(false);
    this.trackPopupToggle();
    /*if (document.getElementsByClassName('peek-overlay').length > 0) {
      let overlay = document.getElementsByClassName('peek-overlay')[0];
      overlay.parentNode.removeChild(overlay);
    }*/
    //this.renderer.(this._el.nativeElement.getElementsByClassName('custom-tooltip')[0], 'top', -5000 + 'px'); we use ngIf now so this doesn't exist
    // }
  }

  @HostListener("click", ["$event"])
  public onClick(event: any): void {
    this.preventRedirect(event);
  }

  // TODO: investigate deeper why we need magic numbers in calculations ('3', '9')
  positioningPopup() {
    let offsetHeight = this._el.nativeElement.getBoundingClientRect().top - this._headerHeight;
    let offsetBottom = window.innerHeight - this._el.nativeElement.getBoundingClientRect().bottom - this._footerHeight;
    let contentAreaHeight = window.innerHeight - this._headerHeight - this._footerHeight;

    let elHeight = this._el.nativeElement.getBoundingClientRect().height;
    let correction = 0;

    let popup = this._el.nativeElement.getElementsByClassName('custom-tooltip')[0];
    let popupInner = this._el.nativeElement.getElementsByClassName('peek-tooltip-inner')[0];
    let popupContent = this._el.nativeElement.getElementsByClassName('tooltip-content')[0];
    let arrow = this._el.nativeElement.getElementsByClassName('tooltip-arrow')[0];
    let arrowMinHeight = 22;
    let popupHeight = popup.offsetHeight;

    // popup bigger than content area
    if (popupHeight > contentAreaHeight) {
      this.renderer.setStyle(popupInner, 'height', contentAreaHeight + 'px');
      popupHeight = contentAreaHeight;
    }
    if ((popupHeight / 2) > (offsetBottom + elHeight / 2)) {
      // popup do not fit from bottom
      correction = -((popupHeight / 2) - (offsetBottom + elHeight / 2) + elHeight / 2 + 3);
    } else if ((popupHeight / 2) > (offsetHeight + elHeight / 2)) {
      // popup do not fit from top
      correction = (popupHeight / 2) - (offsetHeight + elHeight / 2) - elHeight / 2 - 3;
    }

    this.renderer.setStyle(popup, 'left', 27 + 'px');
    this.renderer.setStyle(popup, 'top', -(popupHeight / 2) + correction + 'px');

    if (correction !== 0) {
      this.renderer.setStyle(arrow, 'top', popupHeight / 2 - (correction + elHeight / 2 + arrowMinHeight / 2 - 9) + 'px');
      this.renderer.setStyle(arrow, 'height', arrowMinHeight + 'px');
    } else {
      this.renderer.setStyle(arrow, 'top', '0px');
      this.renderer.setStyle(arrow, 'height', '100%');
    }
    // this.contentContainer.appendChild(this.tmp);
  }
}
